import {
  Box,
  IconButton,
  Stack,
  useTheme,
  Text,
} from '@ltvco/refresh-lib/theme';
import { Close } from '@mui/icons-material';

import { searchpal } from 'images';

export function SearchpalChatbotHeader({ onClose }: { onClose: () => void }) {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      position="sticky"
      top={0}
      zIndex={3000}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxShadow: '0 0 1px -2px rgba(0, 0, 0, 0.2)',
        borderRadius: '16px 16px 0 0',
      })}
    >
      <Stack
        data-testid="searchpal-header"
        direction="row"
        justifyContent="flex-start"
        spacing={1}
        py={1}
        pl={1}
        pb={1}
        width="100%"
      >
        <img src={searchpal} alt="searchpal" />
        <Stack direction="column" alignItems="flex-start">
          <Text
            variant="h5"
            marginTop={1}
            marginBottom={0}
            color={theme.palette.premium.contrastText}
          >
            Search Assistant
          </Text>
          <Stack direction="row">
            <Text
              variant="caption"
              fontSize={'0.7rem'}
              color={theme.palette.premium.contrastText}
            >
              Refine your search results
            </Text>
          </Stack>
        </Stack>
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <IconButton aria-label="Close Chatbot" onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
    </Stack>
  );
}
